import SearchClient from '../search';

export default class UserInfoClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  getAppInstalled = async () => {
    console.log('Checking if app is installed...');
    try {
      const response = await this.request('get')(
        {},
        { path: 'userInfo/appInstalled' },
      );
      console.log('App installed response:', response);
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  inactiveAppToken = async (userid) => {
    try {
      const response = await this.request('put')(
        { userid },
        { path: 'userInfo/inactiveAppToken' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }
}
